const groupOptions = {
  WEEK: "WEEK",
  DAY: "DAY",
};

module.exports = groupOptions;
